// extracted by mini-css-extract-plugin
export default {"lightBlurPreloader":"Spinner_lightBlurPreloader__tgr1S","spinnerSize":"Spinner_spinnerSize__lHdB7","paginationSpinnerSize":"Spinner_paginationSpinnerSize__dFOEf"};